const swiper = new Swiper(".mySwiper", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

function toggleAnswer(element) {
  const togglePart = element;
  togglePart.parentElement.classList.toggle("is-open");
}

function toggleHumburger() {
  const el = document.querySelector("#drawer");
  const elButton = document.querySelector(".menu-button");
  el.classList.toggle("is-open");
  elButton.classList.toggle("is-open");
}

function toggleComment(element) {
  const togglePart = element;
  const el = document.querySelector("#voice .contents.more");

  if (togglePart.classList.contains("is-open")) {
    togglePart.innerHTML = "口コミをもっと見る";
  } else {
    togglePart.innerHTML = "閉じる";
  }
  togglePart.classList.toggle("is-open");
  el.classList.toggle("is-open");
}

const targets = document.getElementsByClassName("fade");
for (let i = targets.length; i--; ) {
  let observer = new IntersectionObserver((entries, observer) => {
    for (let j = entries.length; j--; ) {
      if (entries[j].isIntersecting) {
        entries[j].target.classList.add("active");
        observer.unobserve(entries[j].target);
      }
    }
  });
  observer.observe(targets[i]);
}
